import React, { useEffect, useState } from "react";
import { BSContent, BSOverlay, BottomTitle, CloseButton, Wrapper, TopTitle, HeaderTop, BsHeader } from "./assets/style";
import { CloseIcon } from "./assets/svgIcon";


// Use this BottomSheetModal for: Modal - Level 1 to Level 2
export interface BottomSheetModalProps {
  trackingForScroll?: () => void;
  closeBottomSheetModal?: () => void;
  zIndex?: number;
  bodyClass?: string;
  extraClass?: string;
  pageTitle?: string;
  children?: React.ReactNode;
}

/**
 * @description
 * bottom sheet where scrolling effects are handling
 * tracking for scroll is also passed in passed
 * @param
 * pageTitle: title of bottom sheet
 * closeBottomSheetModal: callbcak for closing bottom sheet
 * extraClass: css class needed to added
 * zindex: zindex of the sheet can be passed
 * trackingForScroll: tracking for scroll is passed
 * @returns bottom sheet with specified options i.e class,children
 */
const BottomSheetModal = ({
  pageTitle = "",
  closeBottomSheetModal,
  children,
  extraClass,
  bodyClass,
  zIndex,
  trackingForScroll,
}: BottomSheetModalProps) => {
  const [isScrollDown, setisScrollDown] = useState("");

  // automatic scroll top when user scrolls up after certain scroll height
  // automatic scroll down after user scrolls down below certain scroll height
  const handleScroll = (e: any) => {
    const height = e.target.scrollTop;
    // interior height of window in pixels, includes height of viewport
    const dheight = window.innerHeight;
    // entire height of an element in pixels, including padding, but not the border, scrollbar or margin.
    const sheight = e.target.scrollHeight;
    // inner height of an element in pixels. It includes padding but excludes borders, margins, and horizontal scrollbars
    const cheight = e.target.clientHeight;
    if (!height) {
      if (cheight < sheight) {
        setisScrollDown(isScrollDown);
      }
      return;
    }
    if (height >= 0.1 * dheight) {
      setisScrollDown(!isScrollDown);
      if (!isScrollDown && trackingForScroll) {
        trackingForScroll();
      }
    } else {
      setisScrollDown(isScrollDown);
      if (isScrollDown && trackingForScroll) {
        trackingForScroll();
      }
    }
  };

  useEffect(() => {
    if (document) {
      const bodySelector = document.querySelector("body");
      bodySelector && bodySelector.setAttribute("style", "overflow: hidden");
    }

    return () => {
      const bodySelector = document.querySelector("body");
      bodySelector && bodySelector.setAttribute("style", "");
    };
  }, []);

  return (
    <Wrapper className={`width-full bottom-sheet ${extraClass}`} zIndex={zIndex}
      onScroll={handleScroll}>
      <BSOverlay className="center-box pos-absolute" zIndex={1} />
      <BSContent className="background layout vertical pos-absolute" zIndex={2} isScrollDown={isScrollDown}>
        <BsHeader className="layout vertical prl15" isScrollDown={isScrollDown}>
          <HeaderTop className="ptb15 prl20 layout horizontal center">
            <CloseButton type="button" className="no-border p0 layout horizontal center-center close-btn"
              onClick={closeBottomSheetModal}>
              <CloseIcon />
            </CloseButton>
            <TopTitle className="layout flex-1 font-semibold mh-v1-title" isScrollDown={isScrollDown}>
              {pageTitle}
            </TopTitle>

          </HeaderTop>
          <BottomTitle className="font-semibold mh-v1-title prl20" isScrollDown={isScrollDown}>
            {pageTitle}
          </BottomTitle>
        </BsHeader>
        <div className={`layout  flex-1 bs-body ${bodyClass}`}>
          {children}
        </div>
      </BSContent>
    </Wrapper>
  );
};

export default BottomSheetModal;
